import React from 'react';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import config from 'config';
/*
This component is used in
components/pages/comparison/charts/dailychart/index.jsx
components/pages/comparison/charts/rangechart/index.jsx
components/pages/comparison/charts/totalchart/index.jsx
components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
components/pages/stats/occupancybreakdown/index.jsx
*/
const optionClicked = (props, mode) => {
    props.chooseMode(mode);
}
const ModeSelector = (props) => {
    return (
        <Dropdown className={props.className} header={props.mode} toggleable>
            <DropdownItem>
                <div onClick={optionClicked.bind(this, props, config.mode.AVERAGE.code)}>
                    {config.mode.AVERAGE.code}
                </div>
            </DropdownItem>
            <DropdownItem>
                <div onClick={optionClicked.bind(this, props, config.mode.PEAK.code)}>
                    {config.mode.PEAK.code}
                </div>
            </DropdownItem>
        </Dropdown>
    )
}
export default ModeSelector



// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/modeselector/index.jsx